<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <EXCMCyclicTaskForm
              v-if="item"
              :handle-submit="onSendForm"
              :handle-update-field="updateField"
              :values="item"
              :errors="violations"
              :initial-values="retrieved" />
      <!--<b-row>-->
        <!--<b-col>-->
          <!--<b-card>-->
            <!--<div class="card-header">-->
              <!--<h4 class="card-title">{{$t('views.excmconsent.update.title')}} {{ item && item['title'] }}</h4>-->
            <!--</div>-->
            <!--<div class="card-body">-->
              <!--<b-row>-->
                <!--<b-col>-->
                  <!--<EXCMCyclicTaskForm-->
                          <!--v-if="item"-->
                          <!--:handle-submit="onSendForm"-->
                          <!--:handle-update-field="updateField"-->
                          <!--:values="item"-->
                          <!--:errors="violations"-->
                          <!--:initial-values="retrieved" />-->
                <!--</b-col>-->
              <!--</b-row>-->
            <!--</div>-->
          <!--</b-card>-->
        <!--</b-col>-->
      <!--</b-row>-->
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EXCMCyclicTaskForm from './Form.vue'
import Loader from '../../Layout/Loader'

export default {
  components: {
    EXCMCyclicTaskForm,
    Loader
  },

  props: {
    cyclicTaskId: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      item: {}
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'excmcyclictask/update/isLoading',
      error: 'excmcyclictask/update/error',
      deleteError: 'excmcyclictask/del/error',
      deleteLoading: 'excmcyclictask/del/isLoading',
      created: 'excmcyclictask/create/created',
      deleted: 'excmcyclictask/del/deleted',
      retrieved: 'excmcyclictask/update/retrieved',
      updated: 'excmcyclictask/update/updated',
      violations: 'excmcyclictask/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'EXCMCyclicTaskList' })
    },
    retrieved: function (item) {
      if (item.dateFrom) {
        item.dateFrom = this.$moment(item.dateFrom).format('YYYY-MM-DD')
      }
      if (item.dateTo) {
        item.dateTo = this.$moment(item.dateTo).format('YYYY-MM-DD')
      }
      if (item.taskType) {
        item.taskType = item.taskType['@id']
      }
      if (item.caseGenre) {
        item.caseGenre = item.caseGenre['@id']
      }
      if (item.caseType) {
        item.caseType = item.caseType['@id']
      }
    },
    updated: function (updated) {
      if (this.$route.name === 'EXCMAgreementShow') {
        this.$store.state.modals.excmcyclictask.update.updated = 1
      }
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    if (this.$route.name === 'EXCMAgreementShow' && this.cyclicTaskId) {
      this.retrieve(decodeURIComponent(this.cyclicTaskId))
    } else {
      this.retrieve(decodeURIComponent(this.$route.params.id))
    }
  },

  methods: {
    ...mapActions({
      createReset: 'excmcyclictask/create/reset',
      deleteItem: 'excmcyclictask/del/del',
      delReset: 'excmcyclictask/del/reset',
      retrieve: 'excmcyclictask/update/retrieve',
      updateReset: 'excmcyclictask/update/reset',
      update: 'excmcyclictask/update/update',
      updateRetrieved: 'excmcyclictask/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this excmcyclictask ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      if (this.retrieved.daysInterval) {
        this.retrieved.daysInterval = parseInt(this.retrieved.daysInterval)
      }
      if (this.retrieved.dateFrom) {
        this.retrieved.dateFrom = this.$moment(this.retrieved.dateFrom).format('YYYY-MM-DD')
      }
      if (this.retrieved.dateTo) {
        this.retrieved.dateTo = this.$moment(this.retrieved.dateTo).format('YYYY-MM-DD')
      }
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
